import { PendingButton } from "@/components/common/PendingButton/PendingButton"
import type { TemplateSettingsPatch } from "@/features/material-compliance/api/templateSettingsApi"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import type { TemplateSettingsSaver } from "../hooks/useTemplateSettingsSave"
import { SavedMark } from "./SavedMark"
import { useUnsavedChanges } from "./UnsavedChanges"

/** A section's Save button for inquiry settings. Hidden for people who may
 *  only view them; blocked while any save on the page runs. Also reports the
 *  section's unsaved edits, so leaving the page asks first. */
export function TemplateSaveButton({
  saver,
  saveKey,
  dirty,
  invalid = false,
  patch,
}: {
  saver: TemplateSettingsSaver
  /** Names this button, so only it shows the spinner. */
  saveKey: string
  dirty: boolean
  invalid?: boolean
  /** Called on click: the fields this section saves. */
  patch: () => TemplateSettingsPatch
}) {
  const { translate } = useTranslation()
  useUnsavedChanges(dirty && saver.canEdit)
  if (!saver.canEdit) return null
  return (
    <>
      <PendingButton
        pending={saver.savingKey === saveKey}
        disabled={!dirty || invalid || saver.busy}
        onClick={() => void saver.save(saveKey, patch())}
      >
        {translate("MC_TPL_SAVE")}
      </PendingButton>
      {!dirty && saver.savedKey === saveKey && <SavedMark />}
    </>
  )
}
